import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import PasswordInput from '../components/ui/PasswordInput';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { ArrowLeft } from 'lucide-react';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      toast.success('Login successful!');
      navigate('/dashboard');
    } else {
      toast.error(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      {/* Back to Homepage Link */}
      <Link 
        to="/" 
        className="absolute top-6 left-6 flex items-center gap-2 text-slate-600 hover:text-primary font-jakarta text-sm transition-colors duration-200"
      >
        <ArrowLeft className="w-4 h-4" />
        Back to Homepage
      </Link>

      <div className="w-full max-w-md">
        {/* Logo/Brand */}
        <div className="text-center mb-8">
          <img
            src="/kaizen-events-logo.png"
            alt="Kaizen Events"
            className="h-16 sm:h-20 w-auto mx-auto mb-3"
          />
          <p className="text-slate-600 font-jakarta">Campaign Registration Admin Panel</p>
        </div>

        {/* Login Card */}
        <div className="bg-white rounded-xl border border-slate-100 shadow-card p-8">
          <h2 className="text-2xl font-outfit font-semibold text-slate-900 mb-6">Sign In</h2>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Label htmlFor="email" className="text-slate-700 font-jakarta font-medium mb-2 block">
                Email Address
              </Label>
              <Input
                id="email"
                type="email"
                placeholder="admin@kaizenevents.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="login-email-input"
                className="h-11 rounded-lg border-slate-200 focus-visible:ring-primary transition-all duration-200"
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-slate-700 font-jakarta font-medium mb-2 block">
                Password
              </Label>
              <PasswordInput
                id="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="login-password-input"
                className="h-11 rounded-lg border-slate-200 focus-visible:ring-primary transition-all duration-200"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              data-testid="login-submit-button"
              className="w-full h-11 bg-primary hover:bg-primary-hover text-primary-foreground font-jakarta font-medium rounded-lg shadow-lg shadow-primary/20 transition-all duration-200 active:scale-95"
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <Link
              to="/forgot-password"
              className="text-sm text-primary hover:text-primary-hover font-jakarta font-medium transition-colors duration-200"
            >
              Forgot your password?
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
